import { format, parseISO } from 'date-fns';

export type RangeKey = 'AllDay' | 'Morning' | 'Afternoon' | 'Evening';

export type Availability = {
  date: string;
  times: RangeKey[];
};

export const TIME_RANGES: Record<
  RangeKey,
  { label: string; timeRange: string; startHour: number; endHour: number }
> = {
  AllDay: {
    label: 'All Day',
    timeRange: '(9AM - 6PM)',
    startHour: 9,
    endHour: 18,
  },
  Morning: {
    label: 'Morning',
    timeRange: '(9AM - Noon)',
    startHour: 9,
    endHour: 12,
  },
  Afternoon: {
    label: 'Afternoon',
    timeRange: '(Noon - 3PM)',
    startHour: 12,
    endHour: 15,
  },
  Evening: {
    label: 'Evening',
    timeRange: '(3PM - 6PM)',
    startHour: 15,
    endHour: 18,
  },
};

/** The API may send `2026-10-05T00:00:00`; the pickers work with `2026-10-05`. */
export function toDateOnly(date: string) {
  return date.slice(0, 10);
}

/**
 * Formats a date-only string as the calendar day it names. Converting it to a
 * time zone first (`utcToZonedTime(parseISO(date), tz)`) shifts it to the
 * previous day whenever the browser is ahead of the home's time zone.
 */
export function formatDateOnly(date: string, dateFormat: string) {
  return format(parseISO(toDateOnly(date)), dateFormat);
}
